export default __webpack_public_path__ + "assets/horse-giving-boss-a-bath-5537c313cc36eb932c799f33592fba14.png";